import { ApiFetcher, ApiFetcherContext, BrowserPlatformServer } from 'all-in-one-shared-api';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { RequireAuth } from './auth/RequireAuth';
import HomePage from './pages/home/HomePage';
import LoginPage from './pages/life/login/LoginPage';
import ForgotPasswordWithEmailPage from './pages/life/forget/ForgotPasswordWithEmailPage';
import ForgotPasswordWithMobilePage from './pages/life/forget/ForgotPasswordWithMobilePage';
import ProfilePage from './pages/profile';
import { SecOtpVerificationPage } from './pages/profile/components/otp-verification/SecOtpVerificationPage';
import { PrimaryOtpVerificationPage } from './pages/profile/components/otp-verification/primaryOtpVerificationPage';
import { MfaOtp } from './pages/life/login/otp-verification/mfaOtp';

import DependentPage from './pages/dependents';
import MedicalCardPage from './pages/medicalCard';
import SettingsPage from './pages/settings';
import {
  Registration,
  RegistrationSelectPage,
  LifeRegistrationLandingPage,
  LifeRegistrationSubmissionPage,
  RegistrationConfirmPage,
  EbConnectPolicy,
  EbCreateProfile,
  EbConfirm,
} from './pages/life/registration';
import ResetPasswordPage from './pages/resetPassword/ResetPasswordPage';
import ClaimPropertiesContextProvider from 'contexts/claimProperties';
import { initialState, RegistrationFlowContext } from './contexts/registration/context';
import { reducer } from './contexts/registration/reducer';
import { useReducer, useState } from 'react';
import { ErrorBoundary, ProfileLayout } from 'components';
import Layout from 'components/Layout';
import ClaimsPage from 'pages/claims/ClaimsPage';
import { AddClaimDocumentsPage, ClaimDetailsPage, EditClaimPage } from 'pages/claimDetails';
import NewClaimPage from 'pages/newClaim/NewClaimPage';
import { ConfigProvider, Row as AntdRow, Space } from 'antd';
import HomeBanner from './assets/images/home/home-banner.svg';
// import LiBanner from './assets/images/home/life-insurance-banner.svg';
import BenefitsPage from 'pages/benefits/BenefitsPage';
import DocumentsPage from 'pages/documents/DocumentsPage';
import { EnquiryPage } from 'pages/help/enquiry';
import FaqPage from 'pages/help/FaqPage';
import UserGuidePage from 'pages/help/UserGuidePage';
import InboxPage from 'pages/inbox/InboxPage';
import ForgotLoginPage from 'pages/life/forget/ForgotLoginPage';
import ForgotLoginSuccess from 'pages/life/forget/ForgotLoginSuccess';
import ForgotPasswordPage from 'pages/life/forget/ForgotPasswordPage';
import ForgotPasswordOrLogin from 'pages/forget/ForgetPasswordOrLogin';
import ForgotPasswordResetPage from 'pages/life/forget/ForgotPasswordResetPage';
import { ForgotSuccessPage } from 'pages/forget/ForgotSuccessPage';
import { CreditCardSuccessPage } from 'pages/lifeInPayment/CreditCardSuccessPage';
import ClaimHistoryPage from 'pages/claimHistory';
import { WeCareLoginPage } from 'pages/migration';
import NetworkDoctorsPage from 'pages/networkDoctors/NetworkDoctorsPage';
import { PaymentSuccess, ShortfallPage, ShortfallSettlePage } from 'pages/shortfall';
import styled from 'styled-components';
import 'App.less';
import ManageDependentsPage from 'pages/dependents/manage/ManageDependentsPage';
import InviteDependentsPage from 'pages/dependents/invite/InviteDependentsPage';
import { InviteDependentSuccessPage } from 'pages/dependents/invite/InviteDependentSuccessPage';
import { InboxMessagesContextProvider } from 'contexts/inboxMessages';
import { MigrationFlowContextProvider } from 'contexts/migration/provider';
import MigrationPage from 'pages/migration/MigrationPage';
import { MigrationFirstTimeLoginPage } from 'pages/migration/MigrationFirstTimeLoginPage';
import SurgeryClassificationPage from 'pages/surgery/SurgeryClassificationPage';
import { HomeContextProvider } from 'contexts/home/provider';
import SurgeryEnquiryPage from 'pages/surgery/enquiry/SurgeryEnquiryPage';
import { OtpVerificationPage } from 'pages/life/registration/otp-verification/OtpVerificationPage';
import { LifeForgetOtpVerificationPage } from 'pages/life/forget/otp-verification/LifeForgetOtpVerificationPage';
import { LifeForgetLoginIdOtpPage } from 'pages/life/forget/otp-verification/LifeForgetLoginIdOtpPage';
import { OtpVerificationSuccessPage } from 'pages/life/registration/otp-verification/OtpVerificationSuccessPage';
import { PaymentReturn } from 'pages/payment';
import { LifePaymentReturn } from 'pages/payment';
import { PageNotFound } from 'pages/pageNotFound/PageNotFound';
import { ChangeRequestError } from 'pages/pageNotFound/ChangeRequestError';
import { ChangeRequestErrorpage } from 'pages/pageNotFound/ChangeRequestErrorpage';
import { TeladocPage } from 'pages/teladoc/TeladocPage';
import { TeladocDisclaimerPage } from 'pages/teladoc/TeladocDisclaimerPage';
import PreClaimPage from './pages/preClaim/PreClaimPage';
import { DeclarationStatement } from 'pages/declarationStatement';
// import { PrivacyPolicyPage } from 'pages/privacyPolicy';
import { PaymentSuccessApp } from 'pages/payment';
// import { TermsAndConditionsPage } from 'pages/termsAndConditions';
import HandleAllInOneLinksPage from 'pages/linksAllInOne/HandleAllInOneLinksPage';
import HandleQRCodePage from 'pages/qrcode/HandleQRCodePage';
import { ProfileInfoContextProvider } from './contexts/profileInfo';
import { useScrollToTop } from 'hooks';
import AdminPage from 'pages/admin/AdminPage';
import ViewAsUserPage from 'pages/admin/ViewAsUserPage';
import SystemAnnouncementPage from 'pages/admin/SystemAnnouncementPage';
import SendInboxMessagePage from 'pages/admin/SendInboxMessagePage';
import { useCheckAdminLoggedIn } from 'hooks/useCheckAdminLoggedIn';
import SendInboxMessageSuccessPage from 'pages/admin/SendInboxMessageSuccessPage';
import { ClaimSubmissionSuccessPage } from './pages/newClaim/ClaimSubmissionSuccessPage';
import { ClaimUpdateSuccessPage } from 'pages/newClaim/ClaimUpdateSuccessPage';
import LIHomePage from 'pages/lifeInHome';
import { PaymentsPage } from 'pages/lifeInPayment';
import LIPoliciesPage from 'pages/lifeInPolicies';
import PoliciesDetail from 'pages/PoliciesDetail';
import PoliciesValues from 'pages/PoliciesValues';
import Beneficiaries from 'pages/PoliciesValues/components/viewBeneficiaries';
import PoliciesCorrespondence from 'pages/PoliciesCorrespondence';
// import LIPolicyUpPage from 'pages/lifeInPolicyUp';
import LiBeneficiaries from 'pages/lifeBeneficiaries/beneficiaries';
import ChangeBeneficiaries from 'pages/lifeBeneficiaries/ChangeBeneficiaries';
import SubmitAfterConfirm from 'pages/lifeBeneficiaries/components/SubmitAfterConfirm';
import { LifeBeneficiariesOtpVerificationPage } from 'pages/lifeBeneficiaries/components/otp-verification/LifeBeneficiariesOtpVerificationPage';
import LISupportPage from 'pages/lifeInSupport/SupportPage';
import ContactUsPage from 'pages/lifeInSupport/detaile/ContactUs';
import UserGuide from 'pages/lifeInSupport/UserGuide';
import MakeAnEnquiryPage from 'pages/lifeInSupport/detaile/MakeAnEnquiry';
import UserguidePage from 'pages/lifeInSupport/detaile/Userguide';
import LifeFAQPage from 'pages/lifeInSupport/detaile/FAQ';
import ProfileConnectLife from 'pages/profileAddLife/ProfileConnectLife';
import { LifeFaqDetailsPage } from 'pages/lifeInSupport/detaile/LifeFaqDetailsPage';

import { useTranslation } from 'react-i18next';
import 'moment/locale/zh-cn';
import { getAppLocale } from 'i18n';
import moment from 'moment';
import UpdateAdminPasswordPage from 'pages/updateAdminPassword/UpdateAdminPasswordPage';
import { WeCareLoginView, WeCareDeclarationView } from 'pages/migration/views';
import { HelmetProvider } from 'react-helmet-async';
import ClaimSettlementNoticeDocument from 'pages/documents/components/ClaimSettlementNoticeDocument';
import { LifeInbox } from 'pages/lifeInbox';
import { PaymentDetailsScreen } from 'pages/lifeInPayment/PaymentDetailsScreen';
import Payment from 'pages/lifeInPayment/Payment';
import { AddConfirm } from 'pages/addConfirm';
import { OtpVerificationPageLife } from 'pages/profileAddLife/OtpVerificationPage';
import { OtpVerificationPageEb } from 'pages/profileAddEb/OtpVerificationPage';
import { EbProfileConnectOtp } from 'pages/profileConnect/OtpVerificationPage';
import ProfileConnectEb from 'pages/profileAddEb/ProfileConnectEb';
import EbProfileConnect from 'pages/profileConnect/ProfileConnectEb';
import MakeClaimPage from 'pages/lifeMakeClaim/detaile/MakeClaimPage';
import ClaimEnquiryPage from 'pages/lifeMakeClaim/ClaimEnquiryPage';
import SubmitClaimFormPage from 'pages/lifeMakeClaim/SubmitClaimFormPage';
import { CIOtpVerificationPage } from 'pages/lifeMakeClaim/components/otp-verification/CIOtpVerificationPage';
import { ClaimConfirmPage } from 'pages/lifeMakeClaim/components/ClaimConfirmPage';
import { LifePaymentUploadScreen } from 'pages/lifeInPayment/LifePaymentUploadScreen';
import ChangePwd from 'pages/changePassword/ChangePasswordPage';
import LifeAccount from 'pages/lifeAccount';
import MakeRequestPage from 'pages/lifeMakeRequest/MakeRequest';
import ChangeContactInformation from 'pages/lifeMakeRequest/ChangeContactInformation';
import ChangePaymentArrangement from 'pages/lifeMakeRequest/ChangePaymentArrangement';
import { LifeChangePwdOtpVerificationPage } from 'pages/changePassword/otp-verification/LifeChangePwdOtpVerificationPage';
import { LifeChangePwdSuccess } from 'pages/changePassword/otp-verification/OtpVerificationSuccessPage';
import { LifechgeRequestOtpVerificationPage } from 'pages/lifeMakeRequest/components/otp-verification/LifechgeRequestOtpVerificationPage';
import { LifechgepaymentOtpVerificationPage } from 'pages/lifeMakeRequest/components/otp-verificationchagepayment/LifechgeRequestOtpVerificationPage';
import { PolicyOptionsOtpVerificationPage } from 'pages/lifePolicyOptions/components/PolicyOptionsOtpVerification/PolicyOptionsOtpVerificationPage';
import { LifePageNotFound } from 'pages/pageNotFound/LifePageNotFound';
import ChangePolicyOptions from 'pages/lifePolicyOptions/ChangePolicyOptions';
import GreenSuccessPage from 'pages/greenSuccess';
import { SuccessPage } from 'pages/greenSuccess/noReferenceSuccessPage';
// The English calendar set Sunday as the start day of a week by default
// But the calendar in Chinese has Monday as the start day of a week
// To change that behavior, follow https://4x.ant.design/components/date-picker/#How-to-modify-start-day-of-week
moment.locale('zh-cn', {
  week: {
    dow: 7,
  },
});

console.log('REACT_APP_ENVIRONMENT: ', process.env.REACT_APP_ENVIRONMENT);
console.log('REACT_APP_API_ENV: ', process.env.REACT_APP_API_ENV);

void (async () => {
  if (process.env.REACT_APP_API_ENV === 'mock') {
    const server = new BrowserPlatformServer();
    await server.start();
  }
})();

const Banner = styled(AntdRow)<{ isAdminLoggedin?: boolean }>`
  background-image: url(${HomeBanner});
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 22.5rem;
  position: absolute;
  top: ${(props) => (props.isAdminLoggedin ? '8rem' : '6.15rem')};
`;

// const LBanner = styled(AntdRow)<{ isAdminLoggedin?: boolean }>`
//   background-image: url(${LiBanner});ProfileConnectEb
//   background-size: cover;
//   background-position: center;
//   width: 100%;
//   min-height: 25.4rem;
//   position: absolute;
//   top: ${(props) => (props.isAdminLoggedin ? '8rem' : '6.15rem')};
// `;

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [selectFlag, setSelectFlag] = useState('');
  const location = useLocation();
  const { i18n } = useTranslation();
  useScrollToTop();
  const isAdminLoggedIn = useCheckAdminLoggedIn();
  console.log(i18n.language);

  return (
    <HelmetProvider>
      <ApiFetcherContext.Provider value={new ApiFetcher(process.env.REACT_APP_API_ENV)}>
        <RegistrationFlowContext.Provider value={{ state, dispatch, selectFlag, setSelectFlag }}>
          <ClaimPropertiesContextProvider>
            <HomeContextProvider>
              <MigrationFlowContextProvider>
                <ErrorBoundary>
                  <InboxMessagesContextProvider>
                    <ProfileInfoContextProvider>
                      <ConfigProvider locale={getAppLocale(i18n.language)}>
                        <Routes>
                          <Route
                            element={
                              <Layout
                                placeholder={
                                  location.pathname === '/home' ? (
                                    <Banner isAdminLoggedin={isAdminLoggedIn} />
                                  ) : (
                                    //  : location.pathname === '/LIHome' ? (
                                    //   <LBanner isAdminLoggedin={isAdminLoggedIn} />
                                    // )
                                    <Space />
                                  )
                                }
                              />
                            }
                          >
                            <Route element={<RequireAuth />}>
                              <Route path="home" element={<HomePage />} />
                              <Route path="addConfirm" element={<AddConfirm />} />
                              <Route path="addConfirmEb" element={<AddConfirm />} />
                              <Route path="claims">
                                <Route index element={<ClaimsPage />} />
                                <Route path="new" element={<NewClaimPage />} />
                                <Route path="success" element={<ClaimSubmissionSuccessPage />} />
                                <Route path="edit-success" element={<ClaimUpdateSuccessPage />} />
                                <Route path="pre-claim" element={<PreClaimPage />} />
                                <Route path="shortfall">
                                  <Route index element={<ShortfallPage />} />
                                  <Route path="settle">
                                    <Route index element={<ShortfallSettlePage />} />
                                    <Route path="paymentSuccess" element={<PaymentSuccess />} />
                                  </Route>
                                </Route>
                                <Route path=":claimId">
                                  <Route index element={<ClaimDetailsPage />} />
                                  <Route path="edit" element={<EditClaimPage />} />
                                  <Route path="add-documents" element={<AddClaimDocumentsPage />} />
                                </Route>
                              </Route>
                              <Route path="payment/return" element={<PaymentReturn />} />
                              <Route path="life/payment/return" element={<LifePaymentReturn />} />
                              <Route element={<ProfileLayout />}>
                                <Route path="profile" element={<ProfilePage />} />
                                <Route path="dependents" element={<DependentPage />} />
                                <Route path="medical-card" element={<MedicalCardPage />} />
                                <Route path="settings" element={<SettingsPage />} />
                              </Route>
                              <Route path="primaryOtpVerificationPage" element={<PrimaryOtpVerificationPage />} />
                              <Route path="secOtpVerificationPage" element={<SecOtpVerificationPage />} />
                              <Route path="documents" element={<DocumentsPage />} />
                              <Route path="eob/*" element={<ClaimSettlementNoticeDocument />} />
                              <Route path="enquiry" element={<EnquiryPage />} />
                              <Route path="faq" element={<FaqPage />} />
                              <Route path="user-guide" element={<UserGuidePage />} />
                              <Route path="inbox" element={<InboxPage />} />
                              <Route path="dependents/manage" element={<ManageDependentsPage />} />
                              <Route path="dependents/invite" element={<InviteDependentsPage />} />
                              <Route path="dependents/invite/success" element={<InviteDependentSuccessPage />} />
                              <Route path="network-doctors" element={<NetworkDoctorsPage />} />
                              <Route path="benefits">
                                <Route index element={<BenefitsPage />} />
                                <Route path="surgery-classification">
                                  <Route index element={<SurgeryClassificationPage />} />
                                  <Route path="enquiry" element={<SurgeryEnquiryPage />} />
                                </Route>
                              </Route>
                              <Route path="migration" element={<MigrationPage />}>
                                <Route index element={<MigrationFirstTimeLoginPage />} />
                              </Route>
                              <Route path="teladoc-booking">
                                <Route index element={<TeladocPage isAdminLoggedIn={isAdminLoggedIn} />} />
                                <Route path="disclaimer" element={<TeladocDisclaimerPage />} />
                              </Route>
                              <Route path="admin" element={<AdminPage />}>
                                <Route index element={<ViewAsUserPage />} />
                                <Route path="system-announcement-message" element={<SystemAnnouncementPage />} />
                                <Route path="send-inbox-msg">
                                  <Route index element={<SendInboxMessagePage />} />
                                  <Route path="success" element={<SendInboxMessageSuccessPage />} />
                                </Route>
                              </Route>
                              <Route path="LIHome" element={<LIHomePage />} />
                              <Route path="LifeInbox" element={<LifeInbox />} />
                              <Route path="ProfileConnectLife" element={<ProfileConnectLife />} />
                              <Route path="ProfileConnectEb" element={<ProfileConnectEb />} />
                              <Route path="EbProfileConnect" element={<EbProfileConnect />} />
                              <Route path="LifeAccount" element={<LifeAccount />} />
                              <Route path="changePwd" element={<ChangePwd />} />
                              <Route path="afterOtpVerification" element={<LifeChangePwdOtpVerificationPage />} />
                              <Route path="afterOtpVerificationSuccess" element={<LifeChangePwdSuccess />} />
                              <Route path="LIPayment" element={<Payment />}>
                                <Route index element={<PaymentsPage />} />
                                <Route path="PaymentDetails" element={<PaymentDetailsScreen />} />
                                <Route path="LifePaymentUpload" element={<LifePaymentUploadScreen />} />
                                <Route path="CreditCardSuccess" element={<CreditCardSuccessPage />} />
                              </Route>
                              <Route path="LIPolicies" element={<LIPoliciesPage />} />
                              <Route path="PoliciesDetail" element={<PoliciesDetail />} />
                              <Route path="PoliciesValues" element={<PoliciesValues />} />
                              <Route path="beneficiaries" element={<Beneficiaries />} />
                              <Route path="LIBenefiaries" element={<LiBeneficiaries />}>
                                <Route index element={<ChangeBeneficiaries />} />
                                <Route path="SubmitAfterConfirm" element={<SubmitAfterConfirm />} />
                                <Route
                                  path="LifeBeneficiariesOtpVerificationPage"
                                  element={<LifeBeneficiariesOtpVerificationPage />}
                                />
                              </Route>

                              <Route path="GreenSuccessPage" element={<GreenSuccessPage />} />
                              <Route path="SuccessPage" element={<SuccessPage />} />
                              <Route path="PoliciesCorrespondence" element={<PoliciesCorrespondence />} />
                              {/* <Route path="LIPolicyUp" element={<LIPolicyUpPage />} /> */}
                              <Route path="LIPolicyUp" element={<MakeRequestPage />} />
                              <Route path="LISupport" element={<LISupportPage />} />
                              <Route path="ContactUs" element={<ContactUsPage />} />
                              <Route path="UserGuide" element={<UserGuide />} />
                              <Route path="EnquiryFlow" element={<MakeAnEnquiryPage />} />
                              <Route path="Userguide" element={<UserguidePage />} />
                              <Route path="LifeFAQPage" element={<LifeFAQPage />} />
                              <Route path="LifeFaqDetailsPage" element={<LifeFaqDetailsPage />} />
                              <Route path="MakeClaimPage" element={<MakeClaimPage />} />
                              <Route path="ClaimEnquiryPage" element={<ClaimEnquiryPage />} />
                              <Route path="SubmitClaimFormPage" element={<SubmitClaimFormPage />} />
                              <Route path="CIOtpVerificationPage" element={<CIOtpVerificationPage />} />
                              <Route path="ClaimConfirmPage" element={<ClaimConfirmPage />} />
                              <Route path="MakeRequestPage" element={<MakeRequestPage />} />
                              <Route path="ChangePolicyOptions" element={<ChangePolicyOptions />} />
                              <Route
                                path="LifechgeRequestOtpVerificationPage"
                                element={<LifechgeRequestOtpVerificationPage />}
                              />
                              <Route
                                path="LifechgepaymentOtpVerificationPage"
                                element={<LifechgepaymentOtpVerificationPage />}
                              />
                              <Route
                                path="PolicyOptionsOtpVerificationPage"
                                element={<PolicyOptionsOtpVerificationPage />}
                              />
                              <Route path="ChangePaymentArrangement" element={<ChangePaymentArrangement />} />
                              <Route path="ChangeContactInformation" element={<ChangeContactInformation />} />
                              <Route path="connectLifeOtp" element={<OtpVerificationPageLife />} />
                              <Route path="connectEbOtp" element={<OtpVerificationPageEb />} />
                              <Route path="EbProfileConnectOtp" element={<EbProfileConnectOtp />} />
                            </Route>
                            <Route path="ForgotPasswordWithEmailPage" element={<ForgotPasswordWithEmailPage />} />
                            <Route path="ForgotPasswordWithMobilePage" element={<ForgotPasswordWithMobilePage />} />
                            <Route path="login" element={<LoginPage />} />
                            <Route path="mfaOtp" element={<MfaOtp />} />
                            <Route path="update-password" element={<UpdateAdminPasswordPage />} />
                            <Route path="claims/history" element={<ClaimHistoryPage />} />
                            <Route element={<WeCareLoginPage />}>
                              <Route path="we-care-login" element={<WeCareLoginView />} />
                              <Route path="we-care-login/login-information" element={<WeCareDeclarationView />} />
                            </Route>
                            <Route path="resetPassword" element={<ResetPasswordPage />} />
                            <Route path="register" element={<Registration />}>
                              <Route index element={<RegistrationSelectPage />} />
                              <Route path="LifeRegistrationLanding" element={<LifeRegistrationLandingPage />} />
                              <Route path="LifeRegistrationSubmission" element={<LifeRegistrationSubmissionPage />} />
                              <Route path="RegistrationConfirm" element={<RegistrationConfirmPage />} />
                              <Route path="EbConnectPolicy" element={<EbConnectPolicy />} />
                              <Route path="EbCreateProfile" element={<EbCreateProfile />} />
                              <Route path="EbConfirm" element={<EbConfirm />} />
                              {/* <Route
                                path="success"
                                element={<RegistrationSuccessPage />}
                              />
                              <Route
                                path="success"
                                element={<RegistrationSuccessPage />}
                              /> */}
                              <Route path="otp-verification" element={<OtpVerificationPage />} />
                              <Route path="otp-verification/success" element={<OtpVerificationSuccessPage />} />
                              {/* <Route
                                path="success"
                                element={<RegistrationSuccessPage />}
                              /> */}
                            </Route>
                            <Route path="forgot" element={<ForgotPasswordOrLogin />}>
                              <Route index element={<ForgotLoginPage />} />
                              <Route path="login" element={<ForgotLoginPage />} />
                              <Route path="ForgotLoginSuccess" element={<ForgotLoginSuccess />} />
                              <Route path="password" element={<ForgotPasswordPage />} />
                              <Route path="success" element={<ForgotSuccessPage />} />
                              <Route path="ForgotPasswordWithEmailPage" element={<ForgotPasswordWithEmailPage />} />
                              <Route path="ForgotPasswordWithMobilePage" element={<ForgotPasswordWithMobilePage />} />
                              <Route path="ForgotPasswordReset" element={<ForgotPasswordResetPage />} />
                              <Route path="otp-verification" element={<LifeForgetOtpVerificationPage />} />
                              <Route path="otp-forgot-loginid" element={<LifeForgetLoginIdOtpPage />} />
                            </Route>
                            {/* <Route path="connectLifeOtp" element={<OtpVerificationPageLife />} />
                            <Route path="connectEbOtp" element={<OtpVerificationPageEb />} /> */}

                            {/* <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
                            <Route path="terms-and-conditions" element={<TermsAndConditionsPage />} /> */}
                            <Route path="declaration-statement" element={<DeclarationStatement />} />
                            <Route path="genbravo/payment/return" element={<PaymentSuccessApp />} />
                            <Route path="notFound" element={<PageNotFound />} />
                            <Route path="LifeNotFound" element={<LifePageNotFound />} />
                            <Route path="ChangeRequestError" element={<ChangeRequestError />} />
                            <Route path="ChangeRequestErrorpage" element={<ChangeRequestErrorpage />} />
                            <Route path="" element={<Navigate to="/home" />} />
                            <Route path="*" element={<Navigate to="/notFound" />} />
                          </Route>
                          <Route path="qrcode" element={<HandleQRCodePage />} />
                          <Route path="links/allinone*" element={<HandleAllInOneLinksPage />} />
                        </Routes>
                      </ConfigProvider>
                    </ProfileInfoContextProvider>
                  </InboxMessagesContextProvider>
                </ErrorBoundary>
              </MigrationFlowContextProvider>
            </HomeContextProvider>
          </ClaimPropertiesContextProvider>
        </RegistrationFlowContext.Provider>
      </ApiFetcherContext.Provider>
    </HelmetProvider>
  );
}

export default App;
